"use strict";

require("core-js/modules/es6.object.define-property");

var _styledComponents = _interopRequireDefault(require("styled-components"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.ResizeHandlerInner = exports.ResizeHandler = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

var ResizeHandler = _styledComponents["default"].div.withConfig({
  displayName: "styles__ResizeHandler"
})(["width:12px;right:0px;border:2px solid grey;height:12px;bottom:0px;position:absolute;border-top:0;border-left:0;"]);

exports.ResizeHandler = ResizeHandler;

var ResizeHandlerInner = _styledComponents["default"].div.withConfig({
  displayName: "styles__ResizeHandlerInner"
})(["right:-10px;width:44px;bottom:-10px;cursor:se-resize;height:44px;position:absolute;"]);

exports.ResizeHandlerInner = ResizeHandlerInner;